import headerBg from '@/assets/images/active/sakura/card/header/bg.png';
import headerBg2 from '@/assets/images/active/sakura/card/header/bg_notlogin.png';
import officeBtn from '@/assets/images/active/sakura/card/header/offical.png';
import loginBtn from '@/assets/images/active/sakura/card/header/login.png';
import accountBtn from '@/assets/images/active/sakura/card/header/login.png';
import activeBtn from '@/assets/images/active/sakura/card/header/login.png';
import logoutBtn from '@/assets/images/active/sakura/card/header/loginout.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: ''
  },
  logged_in: {
    background_image: headerBg2,
    main_title_color: '#825339',
    sub_title_color: '#825339',
    tips_color: '#825339',
    height: '1.73rem',
    game_name: '魔卡少女樱'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.2rem;',
      link: 'https://sakura.qingcijoy.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.2rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.2rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.2rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.2rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sakura/card/headerConfig.js